import React from 'react';

const SegmentedButtonItem = ({option, isSelected, onClick }) => {
return (
    <button
        type="button"
        className={`btn ${isSelected ? 'btn-primary' : 'btn-outline-primary'}`}
        onClick={onClick}
    >
        {option}
    </button>);
}

export default SegmentedButtonItem;
